// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"6dc083f6","133":"3571a592","182":"65ec2e00"}[chunkId] + ".chunk.js";
};